export default function clearForm(form) {
    const selects = [...form.querySelectorAll('select')];
    const multiselect = [...form.querySelectorAll('.multiselect')];
    const radioChecboxElements = [...form.querySelectorAll('input[type="radio"], input[type="checkbox"]')];
    const requiredElements = [...form.querySelectorAll('p.required')];
    const defaultElements = [...form.querySelectorAll('textarea:enabled, input:enabled:not([readonly]), select:enabled')];

    selects.forEach((el) => {
        const optionSelected = el.querySelector('option[selected]');
        if (optionSelected) {
            optionSelected.removeAttribute('selected');
        }
    });

    radioChecboxElements.forEach((el) => {
        if (el.indeterminate) el.indeterminate = false;
        el.removeAttribute('checked');
        el.checked = false;
    });

    requiredElements.forEach((el) => {
        el.parentElement.removeChild(el);
    });

    defaultElements.forEach((el) => {
        el.value = '';
    });

    multiselect.forEach((el) => {
        const toggle = el.querySelector('.multiselect__toggle');
        toggle.innerHTML = el.getAttribute('data-placeholder');
    });
}
